const { userRoles } = storeToRefs(useUserStore())

export default defineNuxtRouteMiddleware(async () => {
  if (!userRoles.value.includes('administrator')) {
    return navigateTo('/')
  }
})
